import { FC, useEffect } from "react";
import PopularNow from "./components/PopularNow";
// import FooterHome from "./components/FooterHome";
import homeStore from "./store/homeStore";
import { observer } from "mobx-react-lite";
import { isMobile } from "react-device-detect";
import StoreMap from "./components/StoreMap";
import { Helmet } from "react-helmet-async";
import appStore from "../../stores/appStore";
import Banner from "./components/Banner";
import CategoriesGrid from "./components/CategoriesGrid";
import NewProducts from "./components/NewProducts";
import MobileSearchBar from "../../components/MobileSearchBar";
import CarMakersBanner from "./components/CarMakersBanner";

const Home: FC = () => {
  useEffect(() => {
      homeStore.fetchPopularNow();
      homeStore.fetchStoreLocation();
      homeStore.fetchBanner();
      homeStore.fetchNewProducts();

  }, []);

  // const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div className="flex flex-col gap-[25px] md:gap-[30px] h-max p-4">
      <Helmet>
        <>
          <title>КЦ Авто | Главная</title>
          <meta
            name="description"
            content={`КЦ авто домашняя страница главная страница купить автозапчасти Корея центр`}
          />
          <meta
            name="keywords"
            content="КЦ Авто, интернет магазин автозапчастей, поиск запчастей, купить автозапчасти"
          />
        </>
      </Helmet>
      {isMobile ? <MobileSearchBar /> : false}
      {/* <div className="w-full rounded-2xl bg-[#383181] p-4 text-white font-semibold text-2xl text-center">
        Ежедневно мы улучшаем сайт и добавляем новые функции для вас!
      </div> */}

      {appStore.selectedCity &&
        homeStore.banner &&
        homeStore.banner.cities.includes(appStore.selectedCity) && (
          <Banner banner={homeStore.banner}></Banner>
        )}
      <CarMakersBanner />
        <div className="flex flex-col gap-[25px] md:gap-[30px] mb-[50px]">
      <PopularNow />
      <CategoriesGrid></CategoriesGrid>
      <NewProducts></NewProducts>
      { <StoreMap></StoreMap>}
        </div>

    </div>
  );
};

export default observer(Home);
